// Add your custom JS here.

jQuery(function($) {

  //共通
  var headerH = $("#wrapper-navbar").outerHeight(true);//headerの高さを取得

  // Drawer
  $('.drawer').drawer();

  $(window).on('load scroll', function() {
    var scrollPos = $(this).scrollTop();
    if (scrollPos > 100) {
      $('#wrapper-navbar').addClass('is-animation');
    } else {
      $('#wrapper-navbar').removeClass('is-animation');
    }
  });

  // 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function () {
    FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
  });

  // Button：page top
  // 変数にクラスを入れる
  var btn = $('#page-top');

  //スクロールしてページトップから100に達したらボタンを表示
  $(window).on('load scroll', function(){
    if($(this).scrollTop() > 100) {
      btn.addClass('active');
    }else{
      btn.removeClass('active');
    }
  });

  //フッターの手前でボタンを止める
  $(window).on('load scroll', function(){
    var height = $(document).height(), //ドキュメントの高さ
        position = window.innerHeight + $(window).scrollTop(), //ページトップから現在地までの高さ
        footer = $('#wrapper-footer').height(); //フッターの高さ
    if ( height - position  < footer ){
      btn.addClass('absolute');
    } else {
      btn.removeClass('absolute');
    }
  });


});
